import {AND, CONST, OBJECT, guard} from '@acng/frontend-rubicon';

import {listen} from '../../core/context/event-bus.js';
import {FRIENDSHIP} from '../model/friendship.js';

/**
 * @param {(friendship: Valid<typeof EVENTBUS_FRIENDSHIP>) => void} callback
 */
export const listenFriendshipEvent = (callback) =>
  listen('friendship', (friendship) => {
    ASSERT: guard(friendship, EVENTBUS_FRIENDSHIP, 'friendship event from TROI');

    callback(friendship);
  });

/**
 * Validate the event bus message of type "friendship".
 */
const EVENTBUS_FRIENDSHIP = /* @__PURE__ */ (() => AND(OBJECT({type: CONST('friendship')}), FRIENDSHIP))();
